var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"link",attrs:{"href":_vm.uri,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.resolvedLabel || _vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }